import React from "react";
import "../static/scss/JoinSchool_Box.scss";
import external from "../static/external.svg";

const JoinSchool2_Box = (props) => {
  return (
    <>
      {props ? (
        <div className="schoolCard">
          <div className="soudankai">
            <img src={props.img} alt="" className={props.class} />
            {props.soudankai ? <span>+対面相談会参加</span> : null}
          </div>
          <a
            href={props.url}
            className="hp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <h3>
              {props.name}
              <img src={external} alt="" />
            </h3>
          </a>
          <p className="title">住所</p>
          <p className="address">
            <p>
              札幌大通キャンパス:〒<span>{props.postalCode1}</span>
              {"   "}
              {props.address1}
            </p>
            <p>
              札幌白石キャンパス:〒<span>{props.postalCode2}</span>
              {"   "}
              {props.address2}
            </p>
          </p>
          <p className="title">電話番号</p>
          <p>
            <a href="tel:{props.phoneNumber}">{props.phoneNumber}</a>
          </p>
          <p className="title">学校説明</p>
          <p className="desc"> {props.desc} </p>
        </div>
      ) : null}
    </>
  );
};

export default JoinSchool2_Box;
